import { sanitizeDriveName } from "./driveDealFolder.js";

export const DEFAULT_DRIVE_FOLDER_TEMPLATE = "{display_name} · {deal_id_short}";

export type DriveFolderTokens = {
  year: string;
  month: string;
  display_name: string;
  deal_id_short: string;
  customer: string;
  order: string;
  serial: string;
  office: string;
  slot: string;
};

const TOKEN_KEYS: Array<keyof DriveFolderTokens> = [
  "year",
  "month",
  "display_name",
  "deal_id_short",
  "customer",
  "order",
  "serial",
  "office",
  "slot",
];

function dealIdShort(dealId: string): string {
  return dealId.replace(/-/g, "").slice(0, 8);
}

export function driveFolderTokensFromDeal(args: {
  dealId: string;
  displayName: string | null | undefined;
  createdAt?: string | null;
  customer?: string | null;
  order?: string | null;
  serial?: string | null;
  office?: string | null;
  slot?: string | null;
}): DriveFolderTokens {
  const created = args.createdAt ? new Date(args.createdAt) : null;
  const valid = created && !Number.isNaN(created.getTime());
  const short = dealIdShort(args.dealId);
  return {
    year: valid ? String(created.getUTCFullYear()) : "",
    month: valid ? String(created.getUTCMonth() + 1).padStart(2, "0") : "",
    display_name: (args.displayName ?? "").trim() || `Deal ${short}`,
    deal_id_short: short,
    customer: (args.customer ?? "").trim(),
    order: (args.order ?? "").trim(),
    serial: (args.serial ?? "").trim(),
    office: (args.office ?? "").trim(),
    slot: (args.slot ?? "").trim(),
  };
}

export function fillDriveFolderTokens(raw: string, tokens: DriveFolderTokens): string {
  return TOKEN_KEYS.reduce((acc, key) => {
    const value = sanitizeDriveName(tokens[key] ?? "", "", 120);
    return acc.replaceAll(`{${key}}`, value);
  }, raw);
}

export function expandDriveFolderTemplate(template: string, tokens: DriveFolderTokens): string[] {
  const raw = template.trim() || DEFAULT_DRIVE_FOLDER_TEMPLATE;
  return fillDriveFolderTokens(raw, tokens)
    .split("/")
    .map((seg) => sanitizeDriveName(seg, "", 120))
    .filter((seg) => seg.length > 0);
}
